import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { CreatePasswordPage } from '../create-password/create-password.page';
import { AuthService } from './auth.service';



@Injectable()
export class AuthGuard  {
  constructor(private authService: AuthService, private router: Router, private modalCtrl: ModalController) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {

    if (this.authService.isAuthenticated()) {
      if (this.authService.isNewAccount()) {
        this.modalCtrl.create({
          component: CreatePasswordPage,
          swipeToClose: false,
          keyboardClose: false,
          backdropDismiss: false,
        }).then(modal => {
          modal.present();
        })
      }
      return true;
    }
    this.authService.logout();
    this.router.navigate(['/login']);
    return false


  }
}